import { HubConnectionState } from '@microsoft/signalr'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { setRead } from 'shared/api/socket.api'

const socketSlice = createSlice({
  name: 'socket',
  initialState: {
    status: HubConnectionState.Connecting,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(socketStatusUpdate.fulfilled, (state, { payload }) => {
      state.status = payload
    })
  },
})

export const socketStatusUpdate = createAsyncThunk(
  'socket/socketStatusUpdate',
  async (status: HubConnectionState) => {
    return status
  }
)

export const setSocketMessageAsRead = createAsyncThunk(
  'socket/setSocketMessageAsRead',
  (id: string) => {
    setRead(id)
  }
)

export const { reducer } = socketSlice
